import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { FeedbackSessionService } from './feedback-session.service';

export const ngxFeedbackSessionServiceModule = angular.module('ngxFeedbackSessionServiceModule', [])
	.factory('ngxFeedbackSessionService', downgradeInjectable(FeedbackSessionService) as any)
	.name;
